import { useState } from "react";
import { HiDownload } from "react-icons/hi";
import "./ExportExcel.css";

const ExportExcel = ({ data = [], columns = [], fileName = "my-data.xlsx" }) => {
  const [xlsxModule, setXlsxModule] = useState(null);
  const [exporting, setExporting] = useState(false);

  const loadXLSX = async () => {
    if (xlsxModule) {
      return xlsxModule;
    }
    const module = await import("https://unpkg.com/xlsx/xlsx.mjs");
    setXlsxModule(module);
    return module;
  };

  const flattenData = (rows, selectedColumns) => {
    return rows.map((item) => {
      const flattenedItem = {};
      selectedColumns.forEach((column) => {
        const keys = column.split(".");
        let value = item;

        for (const key of keys) {
          if (value && Object.prototype.hasOwnProperty.call(value, key)) {
            value = value[key];
          } else {
            value = "";
            break;
          }
        }

        flattenedItem[column] = value ?? "";
      });
      return flattenedItem;
    });
  };

  const exportToExcel = async () => {
    if (!Array.isArray(data) || data.length === 0 || columns.length === 0) {
      return;
    }

    setExporting(true);
    try {
      const formattedData = flattenData(data, columns);
      const module = await loadXLSX();
      const worksheet = module.utils.json_to_sheet(formattedData);
      const workbook = module.utils.book_new();
      module.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      module.writeFile(workbook, fileName);
    } finally {
      setExporting(false);
    }
  };

  const disabled = !Array.isArray(data) || data.length === 0 || columns.length === 0;

  return (
    <button
      type="button"
      className="admin-export-btn"
      onClick={exportToExcel}
      disabled={disabled || exporting}
      title={disabled ? "No data to export" : "Download spreadsheet"}
    >
      <HiDownload aria-hidden />
      {exporting ? "Exporting…" : "Export to Excel"}
    </button>
  );
};

export default ExportExcel;
